import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, TextField, useTheme } from '@mui/material';
import React, { memo } from 'react';

import { IExternalInputProps } from '../../../hooks/useSearchFilter/useSearchFilter';

export const TableSearchInput = memo(({ value, onChange, onClear, dataAction }: IExternalInputProps) => {
  const {
    palette: { common },
  } = useTheme();

  return (
    <TextField
      value={value}
      onChange={(a: any) => {
        a.preventDefault();
        onChange(a);
      }}
      placeholder="Search"
      variant="outlined"
      size="small"
      data-action={dataAction}
      slotProps={{
        input: {
          sx: { borderRadius: 0.5, backgroundColor: common.white, width: 286 },
          endAdornment: (
            <InputAdornment position="end">
              {value ? (
                <IconButton size="small" onClick={onClear} data-action="clear_icon">
                  <ClearIcon fontSize="small" />
                </IconButton>
              ) : (
                <SearchIcon data-action={`${dataAction}_icon`} />
              )}
            </InputAdornment>
          ),
          inputProps: {
            'data-action': `${dataAction}_input`,
          },
        },
      }}
    />
  );
});

TableSearchInput.displayName = 'SearchInput';
